import { GetAllResolvedEdiblesResponse } from "api-types";
import { AxiosInstance } from "axios";

import { UseQueryResult, useQuery } from "react-query";

import { getAllResolvedEdibles } from "../menus-client";

export const useAllResolvedEdibles = (
  client: AxiosInstance,
  restaurantUuid: string
): UseQueryResult<GetAllResolvedEdiblesResponse | undefined> => {
  return useQuery<GetAllResolvedEdiblesResponse | undefined>(
    ["resolved-edibles", restaurantUuid],
    () => getAllResolvedEdibles(client, restaurantUuid)
  );
};
